export { EloHandCoinsIcon } from './hand-coins-icon'
